(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayl-home-calculator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.ayl-calc-tab');
    const investmentVal = document.getElementById('calc-val-investment');
    const retailVal = document.getElementById('calc-val-retail-price');
    const revenueVal = document.getElementById('calc-val-revenue');
    const profitVal = document.getElementById('calc-val-profit');
    const subtitleText = document.getElementById('ayl-calc-subtitle-text');
    
    // Data definition for simulator
    const packagesData = {
      "12": {
        name: "Starter (12 piezas)",
        investment: "$2,490",
        retail: "$375",
        revenue: "$4,500",
        profit: "$2,010",
        formula: "12 piezas x $375"
      },
      "24": {
        name: "Emprendedor (24 piezas)",
        investment: "$4,490",
        retail: "$420",
        revenue: "$10,080",
        profit: "$5,590",
        formula: "24 piezas x $420"
      },
      "48": {
        name: "Tienda Pro (48 piezas)",
        investment: "$7,990",
        retail: "$400",
        revenue: "$19,200",
        profit: "$11,210",
        formula: "48 piezas x $400"
      }
    };
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Toggle Active class
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        const pkgKey = tab.dataset.pkg;
        const data = packagesData[pkgKey];
        
        if (data) {
          // Animate and update values
          [investmentVal, retailVal, revenueVal, profitVal].forEach(el => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(5px)';
          });
          
          setTimeout(() => {
            subtitleText.innerHTML = `Ejemplo con el paquete <strong>${data.name}</strong>`;
            investmentVal.textContent = data.investment;
            retailVal.textContent = data.retail;
            revenueVal.textContent = data.revenue;
            profitVal.textContent = data.profit;
            
            // Update the formula description for the multiplication box
            const formulaDesc = revenueVal.nextElementSibling;
            if (formulaDesc) formulaDesc.textContent = data.formula;
            
            [investmentVal, retailVal, revenueVal, profitVal].forEach(el => {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });
          }, 200);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
